module.exports = __webpack_public_path__ + "static/media/hk.1494d302.svg";